/**
 * event listener
 *
 */
scrollToAccordionOpen = function ($obj) {
	if (!$obj.length) return;

	$obj.on('shown.bs.collapse', function (e) {
		var $panel = $(this).closest('.card');
		$('html,body').animate({
			scrollTop: $panel.offset().top - 150
		}, 500);
	});

};


ankerForOpenAccordion = function ($obj) {
	if (!$obj.length) return;

	$obj.on('click', function (e) {
		e.preventDefault();

		var $this = $(this),
			dataAttr = $this.data('open-accordion');

		if (!$('.accordion div[id="' + dataAttr + '"]').hasClass('show')) {
			$('.accordion button[data-target="#' + dataAttr + '"]').click();
		}
	});

};


$(document).ready(function () {

	// init scrollToAccordionOpen
	scrollToAccordionOpen($('.accordion .collapse'));
	ankerForOpenAccordion($('.anker-accordion-wrapper .btn'));
});


//remove ids
$('.collapser').on('click', function () {
	$(this).next().collapse('toggle');
});

$('.collapse').on('shown.bs.collapse', function () {
	$(this).parent().find('.acc-close').removeClass('acc-close').addClass('acc-open');
	$(this).parent().find('.card-header').addClass('active');
}).on('hidden.bs.collapse', function () {
	$(this).parent().find('.acc-open').removeClass('acc-open').addClass('acc-close');
	$(this).parent().find('.card-header').removeClass('active');
});
